import React from 'react';
import { SpinnerFullPage } from 'shared/components/SpinnerFullPage/index.js';
import { getUrlToLandingPage } from "../urls";

export function ManagePage () {
  window.location.href = getUrlToLandingPage();
  return <SpinnerFullPage />;
}
